import { Company, Brand } from ".";
import Entry from "./Entry";

export default class Product extends Entry {
  static type = "products";

  company?: Company;
  brand?: Brand;

  get type(): string {
    return Product.type;
  }
}
